module.exports = __webpack_public_path__ + "img/Instagram.170590f0.jpg";